import { ReactNode } from "react";
import { Helmet } from "react-helmet-async";
import { Header } from "./navigation/Header";
import { Footer } from "./navigation/Footer";
import { ENQUIRY_EMAIL, STRAPLINE, TELEPHONE_E164 } from "@/lib/brand";

type MarketingLayoutProps = {
  children: ReactNode;
};

const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Larasoft",
  url: "https://larasoft.global",
  logo: "https://larasoft.global/LarasoftLogoPortraitWhiteWithClearBackground.svg",
  description: STRAPLINE,
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer support",
    email: ENQUIRY_EMAIL,
    telephone: TELEPHONE_E164,
  },
  sameAs: ["https://www.youtube.com/@larasoftsoftwareglobal"],
};

export function MarketingLayout({ children }: MarketingLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: 'var(--bg)' }}>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(ORGANIZATION_SCHEMA)}
        </script>
      </Helmet>
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}
